import React, { useState } from 'react';
import deviceService from '../services/deviceService';
import { Device } from '../services/deviceService';

interface AddDeviceProps {
  onDeviceAdded: (device: Device) => void;
}

const AddDevice: React.FC<AddDeviceProps> = ({ onDeviceAdded }) => {
  const [deviceHash, setDeviceHash] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!deviceHash.trim()) {
      setError('Device hash is required');
      return;
    }

    setLoading(true);
    try {
      const device = await deviceService.addDevice(deviceHash);
      setSuccess('Device added successfully!');
      setDeviceHash('');
      onDeviceAdded(device);
      // Clear success message after 3 seconds
      setTimeout(() => setSuccess(''), 3000);
    } catch (err: any) {
      const message = err.response?.data?.message || 'Failed to add device';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-device-section">
      <h3>Add New Device</h3>
      <form onSubmit={handleSubmit} className="add-device-form">
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <div className="form-group">
          <label htmlFor="deviceHash">Device Hash</label>
          <input
            type="text"
            id="deviceHash"
            value={deviceHash}
            onChange={(e) => setDeviceHash(e.target.value)}
            placeholder="Enter device hash (e.g., abc123def456...)"
            disabled={loading}
            className="device-hash-input"
          />
        </div>

        <button type="submit" disabled={loading} className="add-device-btn">
          {loading ? 'Adding Device...' : 'Add Device'}
        </button>
      </form>
    </div>
  );
};

export default AddDevice;
